import React, { useEffect, useContext } from "react";
import { Badge, Progress } from "../../fusion";
import { Button, Treegrid } from "cai-fusion";
import DnDFileUpload from "../../fusion/FileUpload/DragAndDrop";
import { ToastContext } from "cai-fusion";

import { ReactComponent as IconTrash } from "../../../images/icon-trash.svg"
import { processFiles } from "../../fusion/FileUpload/helpers";
import { rejectToast } from "../utilities/UploadFeedback";
// Both displays and handles file uploads.
const SymphonyFileHandler = ({files = [], setFiles, noFilesDisplayText, uploadDisplayText, uploadRef}) => {
    const { createToast } = useContext(ToastContext);

    // These two functions are what I needed to do to not immediately navigate when uploading a file.
    const deleteFiles = (fileInd) => {
        let filesCopy = [...files];
        filesCopy = [...filesCopy.slice(0, fileInd), ...filesCopy.slice(fileInd + 1)]
        setFiles([...filesCopy]);
    }

    const handleFileUpload = async (newFiles) => {
        const processedFiles = await processFiles(newFiles);
        setFiles([...files, ...processedFiles]);
        console.log("[FILEHANDLER] Added files. New file list:", ([...files], [...processedFiles]));
    }

    return (
        <>
            {/* File display portion */}
            <Treegrid
                columnSizes={["medium", "32"]}
                isCompact
                className="l-mr-sm"
            >
                { files?.length === 0
                    ? noFilesDisplayText && 
                        <tr className="o-treegrid__row o-treegrid__row--shown">
                            <td className="o-treegrid__cell">{noFilesDisplayText}</td>
                        </tr>
                    : files?.map((file, index) => (
                        <tr className="o-treegrid__row o-treegrid__row--shown" key={index}>
                            <td className="o-treegrid__cell">
                                <span className="a-subtle-text">
                                    <strong>{file.resourceName}</strong>
                                </span>
                                {file?.pendingUpload && (
                                    <span style={{ marginLeft: "20px" }}>
                                        <Badge hue="primary-500" value="New" />
                                    </span>
                                )}
                            </td>
                            <td className="o-treegrid__cell o-treegrid__cell--right-aligned">
                                <button className="a-icon-link a-icon-link--destructive" onClick={(e) => { e.preventDefault(); deleteFiles(index) }}>
                                    <div className="a-icon-link__inner">
                                        <div className="a-icon-link__icon-wrapper">
                                            <IconTrash className="a-icon-link__icon"/>
                                        </div>
                                    </div>
                                </button>
                            </td>
                        </tr>
                    ))
                }
            </Treegrid>
            <div style={{ marginBottom: "20px" }}>
                {/* TODO: Overhaul DnDFileUpload */}
                <DnDFileUpload
                    onFileUpload={handleFileUpload}
                    displayText={uploadDisplayText}
                    targetElementRef={uploadRef}
                    onRejectedFiles={(files) => {
                        rejectToast(files, createToast);
                    }}
                />
            </div>
        </>
    )
}

export default SymphonyFileHandler;
